import { Icon, modal } from "@mc/mc-legacy";
import { any, number } from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import SeznamPriloh from "./SeznamPriloh";

class PrilohyButton extends React.Component {
  static propTypes = {
    itemID: number,
    attachmentCount: number,
  };

  handleZobrazitPrilohy = (id) => {
    const { dispatch } = this.props;

    SignRequestInternalApi.getRequestAttachments(id).then((response) => {
      dispatch(modal.ModalActions.show(SeznamPriloh, { data: response }, "Přílohy", {}));
    });
  };

  render() {
    const { itemID, attachmentCount } = this.props;
    return (
      <Button
        title={`Zobrazit přílohy (${attachmentCount})`}
        className="btn-transparent px-0 py-0 mt-0"
        onClick={() => this.handleZobrazitPrilohy(itemID)}
      >
        <Icon className="prilohy-icon" icon={"file"} />
      </Button>
    );
  }
}
export default connect()(PrilohyButton);
